import type { SocialPlatform } from '../components/icons/SocialIcon';

export interface Platform {
  id: SocialPlatform;
  name: string;
  status: 'available' | 'coming-soon';
  icon: string;
  description?: string;
}

export const SOCIAL_PLATFORMS: Platform[] = [
  {
    id: 'facebook',
    name: 'Facebook',
    status: 'available',
    icon: '/facebook.svg',
    description: 'Social networking and community building'
  },
  {
    id: 'google-business',
    name: 'Google Business',
    status: 'coming-soon',
    icon: '/google-business.svg',
    description: 'Local business presence and customer engagement'
  },
  {
    id: 'instagram',
    name: 'Instagram',
    status: 'available',
    icon: '/instagram.svg',
    description: 'Visual storytelling and lifestyle content'
  },
  {
    id: 'linkedin',
    name: 'LinkedIn',
    status: 'available',
    icon: '/linkedin.svg',
    description: 'Professional networking and business content'
  },
  {
    id: 'pinterest',
    name: 'Pinterest',
    status: 'available',
    icon: '/pinterest.svg',
    description: 'Visual discovery and inspiration'
  },
  {
    id: 'tiktok',
    name: 'TikTok',
    status: 'available',
    icon: '/tiktok.svg',
    description: 'Short-form video content'
  },
  {
    id: 'twitter',
    name: 'Twitter',
    status: 'available',
    icon: '/twitter.svg',
    description: 'Real-time updates and conversations'
  },
  {
    id: 'youtube',
    name: 'YouTube',
    status: 'available',
    icon: '/youtube.svg',
    description: 'Video content and community engagement'
  }
];

export const getAvailablePlatforms = () => {
  return SOCIAL_PLATFORMS.filter(platform => platform.status === 'available');
};

export const getPlatformById = (id: SocialPlatform) => {
  return SOCIAL_PLATFORMS.find(platform => platform.id === id);
};

export const isPlatformAvailable = (id: SocialPlatform) => {
  const platform = getPlatformById(id);
  return platform?.status === 'available';
};

export const getPlatformName = (id: SocialPlatform) => {
  return getPlatformById(id)?.name || id;
};

export const getPlatformIcon = (id: SocialPlatform) => {
  return getPlatformById(id)?.icon;
};